import { Message } from "primereact/message";
import "./index.css";

const NotFound = () => {
  return (
    <div>
      <Message
        severity="warn"
        text="Em desenvolvimento"
        className="w-full justify-content-start not-found-height"
      />
    </div>
  );
};

export default NotFound;
